import { Component, OnInit, Input, ChangeDetectionStrategy } from "@angular/core";
import { DashboardService } from "../../dashboard.service";
import { Usage } from "../../dashboard.model";
import { ChartOptions, ChartType, ChartDataset, ChartConfiguration } from "chart.js";
import { CorpClient } from "src/app/shared-models/client.model";
import { CorpClientsService } from "src/app/corp-clients.service";
import { Auth } from "aws-amplify";
import { CognitoUser } from "@aws-amplify/auth";

@Component({
    selector: "chart-users-usage",
    templateUrl: "./users-usage.component.html",
    styleUrls: ["./users-usage.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UsersUsageComponent implements OnInit {
  data: Usage[];
  isLoading: boolean = false;
  error: string;
  currentClient: CorpClient;

  private _days: number = 90;
  @Input("days")
  set days(value: number) {
    this._days = value;
    this.getData();
  }
  get days(): number {
    return this._days;
  }

  public barChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
            beginAtZero: true,
        },
    },
  };
  public barChartLabels: string[] = [];
  public barChartType: ChartType = "bar";
  public barChartLegend = false;

  public barChartData: ChartDataset[] = [
    {
      data: [],
      label: "Videos",
      backgroundColor: "rgba(0,112,66, .4)",
      borderColor: "#16B65A",
      borderWidth: 1,
      hoverBackgroundColor: "#16B65A",
      hoverBorderColor: "#16B65A",
      fill: true,
      tension: 0.5
    },
  ];

  constructor(
    private api: DashboardService,
    private corpService: CorpClientsService
  ) {
    this.corpService.currentClient.subscribe(async (result) => {
      if (result == null) {
        return;
      }
      this.currentClient = result;
      this.getData();
    });
  }

  ngOnInit() {}

  getData() {
    if (this.currentClient == null) {
      return;
    }
    this.isLoading = true;
    this.api
      .getTeamUsage(this.days, this.currentClient.client_id)
      .then((results) => {
        this.data = results.value;
        this.chartData();
      })
      .catch((error) => {
        this.error = "Could not load chart data at this time.";
        console.log(error);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  chartData() {
    if (!this.data) {
      return;
    }
    this.barChartData[0].data = [];
    this.barChartLabels = [];

    this.data.forEach((element) => {
      this.barChartLabels.push(element.name);
      this.barChartData[0].data.push(element.salesmails);
    });
  }

  // events
  public chartClicked({
    event,
    active,
  }: {
    event: MouseEvent;
    active: {}[];
  }): void {
    //console.log(event, active);
  }

  public chartHovered({
    event,
    active,
  }: {
    event: MouseEvent;
    active: {}[];
  }): void {
    //console.log(event, active);
  }
}
